module.exports = __webpack_public_path__ + "static/media/kadeem.2c971bb2.jpg";